module.exports = __webpack_public_path__ + "./images/d6bb2f1b2b3f96dd8db7936a20bec8dd.webp";